module.exports = __webpack_public_path__ + "img/background-road-landscape.de44aca7.jpeg";